import { fas } from '@fortawesome/free-solid-svg-icons'
import { values } from 'lodash'
export const fontAwesome = {
    /**
     * 圖示清單
     */
    icons: values(fas)
}
